import { translate } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';

export interface KnowledgeHubItem {
    title: string;
    src: string;
    link: string;
}

export const getKnowledgeHubItems = (): KnowledgeHubItem[] => [
    {
        title: translate('logged_out_homepage.de.knowledge_hub.items.legal_hub'),
        link: pathfinder('legal_portal_page_legal_portal'),
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/94e6164cf1aed17824a75dfadbf8b0ad-1755183330048/legalHubLohp.png',
    },
    {
        title: translate('logged_out_homepage.de.knowledge_hub.items.ai_hub'),
        link: pathfinder('ai_services_content_page'),
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/94e6164cf1aed17824a75dfadbf8b0ad-1755183330033/aiHubLohp.png',
    },
    {
        title: translate('logged_out_homepage.de.knowledge_hub.items.guides'),
        link: pathfinder('education_hub_render'),
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/fd9e7116fe215cfb9d4cbfbd33e581cc-1755183366147/guidesLohp.png',
    },
];
